<template>
<section class="content">
    <div>
        <div class="box-body">
            <div :class="addButtonClass">
                <router-link :to="{ name: 'dumpYardCreate', params: { _id: '0' } }">
                    <button class=" btn gradientbt">Add Dump Yard</button>
                </router-link>
            </div>

            <v-server-table ref="dumpYardTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoaded">
                <template slot="beforeBody">
                    <tr v-if="loading" class="VueTables__no-results">
                        <td class="text-center" colspan="6">
                            <pulse-loader></pulse-loader>
                        </td>
                    </tr>
                </template>

                <template slot="action" slot-scope="props">
                    <div class="active_wrp">
                        <a class="fa fa-edit" role="button" v-on:click.stop="action(props.row)"></a>

                        <div class="py-2 text-center row">
                            <label class="toggle">
                                <input class="toggle-checkbox" type="checkbox" :checked="props.row.isActive" @click.prevent="(e) => activateDumpYardModal(props.row)" />
                                <span class="slider"></span>
                                <span class="labels" data-on="Active" data-off="Deactivate"></span>
                            </label>
                        </div>
                    </div>
                </template>
            </v-server-table>
        </div>
    </div>
</section>
</template>

<script>
import {
    eventBus,
    dumpyardService
} from "../../../services";
import {
    USER_ROLES
} from "../../../config";
import {
    ServerTable,
    Event
} from "vue-tables-2";
import {
    mapState
} from "vuex";

import store from "../../../store";
import swal from "sweetalert2";
import moment from "moment";
import dateFormatter from "../../utilities/dateFormate";

export default {
    name: "dumpYard",
    data() {
        return {
            loading: null,
            USER_ROLES: USER_ROLES,
            dumpYardTable: null,
            columns: [
                "cityName",
                "dumpYardName",
                
                "contactNumber",
                "userFirstName",
                "createdAt",
                "action",
            ],
            options: {
                highlightMatches: true,
                headings: {
                    cityName: "City",
                    dumpYardName: "Dump Yard Name",
                   
                    contactNumber: "Contact",
                    userFirstName: "Manager",
                    createdAt: "Created On",
                    action: "Action",
                },
                templates: {
                    createdAt(row, query) {
                        return dateFormatter(query.createdAt);
                        // return moment(query.createdAt).format("DD-MM-YYYY");
                    },
                },
                perPage: 10,
                sortable: [
                    "dumpYardName",
                   
                    "contactNumber",
                    "userFirstName",
                    "createdAt",
                ],
                requestFunction: (request) => {
                    const params = {};
                    params.page = request.page;
                    params.limit = request.limit;
                    if (request.orderBy) {
                        params.sortBy = request.orderBy;
                    }
                    if (request.ascending == 1) {
                        params.sortOrder = "asc";
                    } else {
                        params.sortOrder = "des";
                    }
                    if (request.query.status) {
                        params.status = request.query.status;
                    }
                    if (request.query) {
                        params.searchString = request.query;
                    }
                    this.loading = true;
                    return this.$dumpyardDataRepository
                        .collectionDumpyardList(params)
                        .catch((error) => {
                            console.error("Dump Yard .requestFunction-error:", error);
                        });
                },

                responseAdapter: (response) => {
                    this.loading = false;

                    let dumpYardResponse = [];
                    response.data.docs.forEach((element) => {
                        var dumpYardData = element;                       
                        dumpYardData['contactNumber'] = element.contactNumber ? element.contactNumber : '--';
                        dumpYardData['userFirstName'] = element.user ? element.user.firstName + " " + element.user.lastName : '--';
                        dumpYardResponse.push(dumpYardData);
                    });
                    if (dumpYardResponse.count === 0) {
                        count === 0;
                    }
                    return {
                        data: dumpYardResponse,
                        count: response.data.items.total || 0,
                    };
                },

                customFilters: [{
                    name: "custom_filter",
                    callback: function (row, query) {
                        //	return row.role[0] == query;
                    },
                }, ],
                uniqueKey: "_id",
            },
        };
    },
    computed: {
        addButtonClass() {
            if (this.dumpYardTable) {
                return this.dumpYardTable.count > this.dumpYardTable.limit ||
                    this.dumpYardTable.limit > 10 ?
                    "shift-add-left" :
                    "add-item";
            } else {
                return "add-item";
            }
        },
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        activateDumpYardModal(row) {
            let confirmtext;
            if (row.isActive === true) {
                confirmtext = "Deactivate";
            } else {
                confirmtext = "Activate";
            }
            swal({
                title: `Are you sure you want to ${confirmtext}?`,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#0f6940",
                cancelButtonColor: "#d33",
                confirmButtonText: `Yes, ${confirmtext}`,
            }).then((result) => {
                if (result.value) {
                    this.activateDumpYard(row);
                } else {
                    swal.close();
                }
            });
        },
        activateDumpYard(row) {
            let confirmtext;
            if (row.isActive === true) {
                confirmtext = "Deactivate";
            } else {
                confirmtext = "Activate";
            }
            this.loading = true;
            return dumpyardService
                .updateDumpYardStatus(row._id, !row.isActive)
                .then((response) => {
                    this.loading = false;
                    row.isActive = !row.isActive;
                    this.$snotify.success(
                        `The ${row.dumpYardName} has been marked ${confirmtext}.`
                    );
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("DumpYard.activateDumpYard-error:", error);
                    this.$snotify.error("Activate user failed", "Error!");
                });
        },

        action(row) {
            this.$router.push({
                name: "dumpYardCreate",
                params: {
                    _id: row._id,
                },
                props: row,
            });
        },

        onLoaded() {
            this.dumpYardTable = this.$refs.dumpYardTable;
        },
        clearFilter() {
            this.custom_filter_select = "";
        },
        applyFilter(filter_val) {
            Event.$emit("vue-tables.customFilters::custom_filter", filter_val);
        },
    },
    mounted() {
        if (this.$store.state.auth.user.role.key === "superAdmin") {
            this.options.sortable.push("cityName");
        }
        eventBus.$on("DATA_PUBLISHED", (payload) => {});
    },
};
</script>

<style>
.sorting {
    position: absolute;
    left: 319px;
    z-index: 1000;
    width: 200px;
}

.box-body {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.gradientbt {
    background: #0f6940;
    color: white;
}

/* new css */

.toggle {
    --width: 64px;
    --height: calc(var(--width) / 3);

    position: relative;
    display: inline-block;
    width: var(--width);
    height: var(--height);
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    border-radius: var(--height);
    cursor: pointer;
    margin-bottom: 0px;
    position: relative;
    top: 2px;
}

.toggle input {
    display: none;
}

.toggle .slider {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: var(--height);
    background-color: #ccc;
    transition: all 0.4s ease-in-out;
}

.toggle .slider::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: calc(var(--height));
    height: calc(var(--height));
    border-radius: calc(var(--height) / 2);
    background-color: #fff;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    transition: all 0.4s ease-in-out;
}

.toggle input:checked+.slider {
    background-color: #0f6940;
}

.toggle input:checked+.slider::before {
    transform: translateX(calc(var(--width) - var(--height)));
}

.toggle .labels {
    position: absolute;
    top: 4px;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 10px;
    font-family: sans-serif;
    transition: all 0.4s ease-in-out;
}

.toggle .labels::after {
    content: attr(data-off);
    position: absolute;
    right: 5px;
    color: #4d4d4d;
    opacity: 1;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
    transition: all 0.4s ease-in-out;
}

.toggle .labels::before {
    content: attr(data-on);
    position: absolute;
    left: 5px;
    color: #ffffff;
    opacity: 0;
    text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.4);
    transition: all 0.4s ease-in-out;
}

.toggle input:checked~.labels::after {
    opacity: 0;
}

.toggle input:checked~.labels::before {
    opacity: 1;
}

.active_wrp {
    display: flex;
    align-items: center;
}

.active_wrp a {
    flex: 0 0 30%;
    color: #0f6940;
    margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// dumpYard.vue?a530b9dc